class ProductStickyBar {
    constructor (theme, elem) {
        this._elem = elem
        this._top = 600
        this._bottom = 99999
        this._imageBox = null
    }

    onInit () {
        var actionsBar = document.querySelector('.product__actions')
        if (actionsBar) {
            this._top = actionsBar.offsetTop
        }
        var position = document.querySelector('.product__bottom-bar__position')
        if (position) {
            this._bottom = position.offsetTop + position.offsetHeight + 100
        }
        this._imageBox = document.querySelector('.product-single__photos')
        document.addEventListener('scroll', () => { this.onScroll() })
    }

    onScroll () {
        var mobileAdd = 0
        if (window.innerWidth < 768) {
            if (this._imageBox) {
                mobileAdd = this._imageBox.offsetHeight
            }
        }
        if (window.scrollY > this._top + 100 + mobileAdd) {
            this._elem.classList.add('product__bottom-bar--sticky--active')
        } else {
            this._elem.classList.remove('product__bottom-bar--sticky--active')
        }
        if (window.scrollY > this._bottom - window.innerHeight) {
            this._elem.classList.remove('product__bottom-bar--sticky--active')
            this._elem.classList.remove('product__bottom-bar--sticky')
        } else {
            this._elem.classList.add('product__bottom-bar--sticky')
        }
    }
}

export default ProductStickyBar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductStickyBar.js